import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11L21 11V13H13H11L3 13L3 11H11H13Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
